import { render, staticRenderFns } from "./Schmetterlingiframe.vue?vue&type=template&id=2fa8e3be"
import script from "./Schmetterlingiframe.vue?vue&type=script&lang=js"
export * from "./Schmetterlingiframe.vue?vue&type=script&lang=js"
import style0 from "./Schmetterlingiframe.vue?vue&type=style&index=0&id=2fa8e3be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports